
// import React, { useEffect, useState } from 'react';
// import { motion } from 'framer-motion';
// import zaloIcon from '../assets/images/zalo.svg';

// export default function FloatingZaloButton() {
//   const [show, setShow] = useState(false);

//   useEffect(() => {
//     // Hiện icon sau 2.5s
//     const t = setTimeout(() => setShow(true), 2500);
//     return () => clearTimeout(t);
//   }, []);

//   return (
//     <>
//       <motion.a
//         href="https://zalo.me/84866428869"
//         target="_blank"
//         rel="noopener noreferrer"
//         className="floating-zalo-btn"
//         aria-label="Chat Zalo"
//         initial={{ opacity: 0, y: 120 }}
//         animate={show ? { opacity: 1, y: 0 } : {}}  // Animate vào vị trí
//         transition={{ duration: 0.7, ease: [0.4, 0.8, 0.2, 1] }}
//       >
//         <img
//           src={zaloIcon}
//           alt="Zalo"
//           width={44}
//           height={44}
//           style={{ borderRadius: 16, boxShadow: '0 2px 8px #ac88f333' }}
//         />
//       </motion.a>
//       <style>{`
//         .floating-zalo-btn {
//           position: fixed;
//           right: 20px;
//           bottom: 26px;
//           z-index: 2000;
//           background: #fff;
//           border-radius: 16px;
//           box-shadow: 0 2px 24px #9c73ee44;
//           padding: 2px;
//           display: flex;
//           align-items: center;
//           transition: box-shadow .18s, transform .15s;
//         }
//         .floating-zalo-btn:hover {
//           box-shadow: 0 6px 32px #7b42e6aa;
//           transform: scale(1.06);
//         }
//         @media (max-width: 600px) {
//           .floating-zalo-btn {
//             right: 13px;
//             bottom: 16px;
//             width: 38px;
//             height: 38px;
//             padding: 1px;
//           }
//           .floating-zalo-btn img {
//             width: 36px !important;
//             height: 36px !important;
//           }
//         }
//       `}</style>
//     </>
//   );
// }
import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import zaloIcon from '../assets/images/zalo.svg';

export default function FloatingZaloButton() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setShow(true), 2500);
    return () => clearTimeout(t);
  }, []);

  return (
    <>
      <motion.a
        href="https://zalo.me/84866428869"
        target="_blank"
        rel="noopener noreferrer"
        className="floating-zalo-btn"
        aria-label="Chat Zalo"
        initial={{ opacity: 0, y: 120 }}
        animate={show ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.7, ease: [0.4, 0.8, 0.2, 1] }}
      >
        <img
          src={zaloIcon}
          alt="Zalo"
          width={60}
          height={60}
          style={{
            borderRadius: "50%",
            boxShadow: '0 2px 12px #ac88f344', // Nhẹ hơn và tự nhiên hơn
            background: 'transparent',
            display: 'block',
          }}
        />
      </motion.a>
      <style>{`
        .floating-zalo-btn {
          position: fixed;
          right: 35px;
          bottom: 96px;
          z-index: 2000;
          display: flex;
          align-items: center;
          border-radius: 50%;
          transition: box-shadow .18s, transform .15s;
          background: none !important;
          padding: 0 !important;
          box-shadow: none !important;
        }
        .floating-zalo-btn:hover img {
          box-shadow: 0 6px 32px #7b42e6aa;
          transform: scale(1.08);
        }
        @media (max-width: 600px) {
          .floating-zalo-btn {
            right: 33px;
            bottom: 92px;
          }
          .floating-zalo-btn img {
            width: 60px !important;
            height: 60px !important;
          }
        }
      `}</style>
    </>
  );
}
